// extracted by mini-css-extract-plugin
export default {"pic":"index_pic_mzVYy"};